import React from "react";
import { ShieldX, ArrowLeft } from "lucide-react";
import { useHistory } from "react-router-dom";

const Forbidden = () => {
  const history = useHistory();

  return (
    <div className="min-h-screen bg-[#191c1e] flex items-center justify-center p-4">
      <div className="neumorphic-card rounded-3xl p-8 sm:p-10 max-w-md w-full text-center border border-white/10 space-y-5">
        <div className="w-16 h-16 rounded-2xl bg-rose-500/10 border border-rose-500/20 text-rose-400 flex items-center justify-center mx-auto">
          <ShieldX size={32} />
        </div>
        <h1 className="text-2xl font-extrabold text-white">Acesso Restrito</h1>
        <p className="text-xs text-gray-400">
          Este portal é exclusivo para superadministradores. Caso acredite que seja um erro, entre em contato com o suporte técnico.
        </p>
        <button
          onClick={() => history.replace("/login")}
          className="w-full py-3 px-6 create-event-btn text-xs font-bold text-white rounded-xl shadow-purple-glow flex items-center justify-center gap-2"
        >
          <ArrowLeft size={16} /> Voltar para o Login
        </button>
      </div>
    </div>
  );
};

export default Forbidden;
